import { isMobile } from 'react-device-detect';

import { theme } from 'shared/styles/theme';
import { Box } from 'shared/ui/Box';

import styled from '@emotion/styled';

export const RootStyled = styled(Box)`
  padding-top: ${isMobile ? 0 : theme.space[6]};
  padding-bottom: ${isMobile ? 0 : theme.space[6]};
  position: ${isMobile ? 'static' : 'sticky'};
  top: ${isMobile ? 'auto' : 0};
  z-index: ${isMobile ? 'auto' : 11};
  background-color: white;
  height: 95%;
  ${!isMobile &&
  `
   &:after {
      top: 0;
      width: 100%;
      height: 142px;
      left: -5px;
      content: '';
      position: absolute;
      z-index: -1;
    }`}
`;

export const HeaderStyled = styled(Box)`
  width: 100%;
  display: flex;
  position: ${isMobile ? 'fixed' : 'sticky'};
  padding: ${isMobile ? theme.space[4] : theme.space[6]};
  border-radius: ${isMobile ? 0 : theme.borderRadius};
  justify-content: space-between;
  align-items: center;
  margin-right: ${theme.space[6]};
  background-color: ${theme.colors.yellow800};
  z-index: 10;
  top: ${isMobile ? 'auto' : 0};
  ${isMobile ? 'border-bottom: 2px solid #000' : 'border:  2px solid #000'};
`;
